export default __webpack_public_path__ + "static/media/compass.13f01308.svg";